import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SubmissionsState } from './submissions.reducer';

const selectState = createFeatureSelector<SubmissionsState>('submissions');

export const selectIsLoading = createSelector(
  selectState,
  (state: SubmissionsState) => {
    return state.isLoading;
  }
);

export const selectSubmissions = createSelector(
  selectState,
  (state: SubmissionsState) => {
    return state.submissions;
  }
);

export const selectFilters = createSelector(
  selectState,
  (state: SubmissionsState) => {
    return state.filters;
  }
);

export const selectStudySaleSubmissions = createSelector(
  selectState,
  (state: SubmissionsState) => {
    return state.studySubmissions;
  }
);

export const selectDraftSubmissionCount = createSelector(
  selectState,
  (state: SubmissionsState) => {
    return state.draftSubmissionCount;
  }
);
